export const SLUG_SEPARATOR = '${slugs}';
export const GAP_BETWEEN_ITEMS = 24;
export const GAP_BETWEEN_ITEMS_MOBILE = 16;
export const CARD_ITEM_SETTINGS = {
    sm: {
        width: '242px',
    },
    md: {
        width: '162px',
    },
    lg: {
        width: '318px',
    },
};
